{"version":"1.0.0","commit":"01e2955","stage":"dev","builtAt":"2026-10-27T14:25:19.477Z"}